import {
  capDraft,
  VOICE_DRAFT_STORAGE_KEY,
  type DraftStorage,
  type VoiceDraftV1,
} from "@/hooks/voice/voiceDraft";
import { Preferences } from "@capacitor/preferences";

/**
 * Voice-draft store backed by Capacitor Preferences (iOS UserDefaults), which
 * survives WKWebView storage eviction — the reason the native app does not
 * just use localStorage. Lives here because everything that imports a
 * Capacitor plugin lives in src/native/.
 */
export class NativeDraftStorage implements DraftStorage {
  async load(): Promise<VoiceDraftV1 | null> {
    try {
      const { value } = await Preferences.get({ key: VOICE_DRAFT_STORAGE_KEY });
      return value ? (JSON.parse(value) as VoiceDraftV1) : null;
    } catch {
      return null;
    }
  }

  async save(draft: VoiceDraftV1): Promise<void> {
    await Preferences.set({
      key: VOICE_DRAFT_STORAGE_KEY,
      value: JSON.stringify(capDraft(draft)),
    });
  }

  async clear(): Promise<void> {
    await Preferences.remove({ key: VOICE_DRAFT_STORAGE_KEY }).catch(
      () => undefined,
    );
  }
}
